(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("dailyFinancesActions", dailyFinancesActionsFactory);

  /** @ngInject */
  function dailyFinancesActionsFactory($q, api, dispatcher, ActionTypesEnum) {
    return {
      getData: getData,
      getDailyFinances: getDailyFinances,
      getDailyFinancesBySerialNumber: getDailyFinancesBySerialNumber
    };

    function getData() {
      var deferred = $q.defer();

      api.getDailyFinances().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getDailyFinances() {
      api.getDailyFinances().then(
        function (data) {
          dispatcher.dispatch({
            type: ActionTypesEnum.GET_DAILY_FINANCES,
            payload: data
          });
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );
    }

    function getDailyFinancesBySerialNumber(serialNumber) {
      api.getDailyFinancesBySerialNumber(serialNumber).then(
        function (data) {
          dispatcher.dispatch({
            type: ActionTypesEnum.GET_DAILY_FINANCES_FOR_DEVICE,
            payload: data
          });
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );
    }
  }
})();
